import camelize from "lodash/fp";

export const Current = new Proxy(
  {},
  {
    get(target, propertyName) {
      const result = {};
      const prefix = `current-${propertyName}-`;
      for (const meta of document.head.querySelectorAll(`meta[name^=${prefix}]`)) {
        const { name, content } = meta;
        const type = meta.getAttribute("type");

        const key = camelize(name.slice(prefix.length));

        // Defaults to string
        switch (type) {
          case "integer":
            result[key] = parseInt(content, 10);
            break;
          case "boolean":
            result[key] = content.toLowerCase() === "true";
            break;
          default:
            result[key] = content;
        }
      }
      return result;
    },
  },
);
